import styled from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-width: 1100px;
  padding-top: 0px;
  text-align: left;
  z-index: 10000000000;
  &.flexible {
    min-width: auto;
  }

  .inner {
    width: 95%;
    max-width: 1400px;
    margin: auto;
    text-align: left;
    position: relative;
    z-index: 10000000000;

    &.floating {
      max-width: none;
      /* width: 100%; */
      padding: 0;

      .doc-list {
        padding: 10px 0;
      }

      &.right {
        background: var(--floating-menu-background);
        padding: 10px 13px 9px 3px;
        border-radius: 25px;
      }
    }

    .doc-list {
      left: 0px;
      top: 0px;
      position: absolute;
      padding: 8px;

      svg {
        vertical-align: middle;
        position: relative;
        margin-right: 3px;
        opacity: 1;

        path {
          fill: var(--grey-0);
          stroke: var(--grey-0);
        }
      }
    }

    .right {
      position: absolute;
      right: 0px;
      top: 0;
      padding: 8px;
    }

    .membership-status {
      float: right;
      font-size: 15px;

      .status-text {
        font-family: Inter;
        font-size: 13px;
        /* margin-right: 1em; */
        opacity: 0.8;
        line-height: 2.3em;
        color: var(--grey-0);

        a {
          color: var(--grey-0);
        }

        i {
          margin-left: 0.25em;
          width: 10px;
          display: inline-block;
        }
      }

      .pill-link,
      .changelog {
        background: var(--container-color);
        color: var(--grey-1);
        border-radius: 20px;
        font-size: 13px;
        font-family: Inter;
        font-weight: 500;
        position: relative;
        text-decoration: none;
        padding: 4px 14px;
        line-height: 1.6em;
        margin-right: 1em;

        span {
          display: inline-block;
          // width: 5px;
          height: 10px;
          margin: 0;
          padding: 0;
        }
      }

      [data-badge-changelog]::after {
        font-size: 0;
        right: 0;
        top: 0;
        height: 6px;
        width: 6px;
        margin-right: 7px;
        // position: relative;
        // top: -1px;
        margin-left: 0;
        padding: 0;
        position: relative;
        // display: inline-block;
      }

      a svg {
        path {
          fill: var(--grey-0);
        }
      }

      .hiring-tag {
        background: var(--container-color);
        color: var(--grey-1);

        padding: 4px 16px;
        border-radius: 20px;
        font-size: 13px;
        font-family: Inter;
        font-weight: 500;

        a {
          padding: 0;
          text-decoration: none;
          color: var(--grey-1);
        }
      }

      span {
        a {
          padding-left: 16px;
        }

        display: flex;
        align-items: flex-end;
      }

      strong {
        color: var(--primary-cta);
      }

      a {
        color: black;
        text-decoration: underline;
      }

      .labs-link-container {
        position: relative;
        z-index: 10001;
        margin-right: 10px;

        svg {
          height: 24px;
          width: 24px;
        }
      }

      .new {
        font-size: 12px;
        background: red;
        color: white;
        padding: 3px 5px;
        display: inline-block;
        border-radius: 3px;
        position: relative;
        top: -2px;
      }
    }

    #help-container {
      float: right;
      margin-right: 10px;
    }

    ul {
      li {
        margin-bottom: 10px;

        a {
          position: relative;
          padding: 7px 12px;
          border-radius: 10px;
          margin-right: 10px;
          float: left;
          margin-bottom: 10px;
          display: block;
          color: black;
          font-size: 14px;
          text-decoration: none;
          border-width: none;

          .new {
            position: absolute;
            top: -10px;
            right: -10px;
            color: white;
            background: red;
            padding: 5px;
            border-radius: 5px;
            font-size: 10px;
          }

          svg {
            vertical-align: middle;
          }

          &:hover {
            background: linear-gradient(180deg, lighten(rgba(242, 254, 255, 0.82), 15%) 0%, lighten(rgba(233, 254, 255, 0.82), 15%) 100%);
          }

          &.selected {
            background: linear-gradient(180deg, hsla(0, 0%, 100%, 0.5), hsla(0, 0%, 100%, 0.75));
          }

          &.profile-photo {
            margin-top: 3px;
            padding: 0px 0 0 5px;
            background: none;

            &:hover {
              background: none;
            }

            img {
              border: 1px solid $purple;
              width: 25px;
              height: 25px;
              object-fit: cover;
              border-radius: 50%;
            }
          }

          &.nav-characters {
            padding: 3px 12px;
          }
        }
      }
    }
  }
`;
